/* ============================================================
   rababf_tradein_elite_2607
   MergeScreens Trade-In Elite landing page — behaviors
   FAQ accordion, sticky CTA bar, Apple-style scroll reveals.
   Everything is scoped to #rababf_tradein_elite_2607 and runs
   only when the section is on the page.
   ============================================================ */
(function () {
  var root = document.getElementById('rababf_tradein_elite_2607');
  if (!root) return;

  /* FAQ accordion */
  root.querySelectorAll('.rte-faq-q').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var faq = btn.parentElement;
      var ans = faq.querySelector('.rte-faq-a');
      var open = faq.classList.toggle('rte-open');
      btn.setAttribute('aria-expanded', open);
      ans.style.maxHeight = open ? ans.scrollHeight + 'px' : 0;
    });
  });

  /* Sticky bar: show after the hero, hide near the final CTA */
  var bar = root.querySelector('.rte-sticky-bar');
  var hero = root.querySelector('.rte-hero');
  var finalSec = root.querySelector('.rte-final');
  if (bar && hero && finalSec) {
    var toggleBar = function () {
      var heroBottom = hero.getBoundingClientRect().bottom;
      var nearEnd = finalSec.getBoundingClientRect().top < window.innerHeight;
      var show = heroBottom < 0 && !nearEnd;
      bar.classList.toggle('rte-on', show);
      bar.setAttribute('aria-hidden', !show);
    };
    window.addEventListener('scroll', toggleBar, { passive: true });
    toggleBar();
  }

  /* Scroll reveals (skipped for reduced-motion users) */
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = root.querySelectorAll('.rte-reveal');
  if (reduced || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('rte-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('rte-in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }
})();
